module.exports = __webpack_public_path__ + "static/media/Nov21-F19.9ff5dbf4.png";